import { render } from "./asset-type.vue?vue&type=template&id=2fe7f4ff"
import script from "./asset-type.vue?vue&type=script&lang=js"
export * from "./asset-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__